// extracted by mini-css-extract-plugin
export default {"drawer":"non-academic-activity_drawer__WuusX","main_layout":"non-academic-activity_main_layout__FpN2i","container":"non-academic-activity_container__VxCsm"};